import type { CorrectionsAppliedModalProjectPayload, Project } from '@/api/client';
import { projectReviewDeadlineToDisplay, reviewDeadlineDisplayToApi } from '@/utils/emailDateUtils';

export interface CorrectionsAppliedFormState {
  note: string;
  /** «Завершить проверку правок до» из поля, дд.мм.гггг; пусто — срок снимается */
  reviewDeadline: string;
}

/** Поле срока при открытии окна: срок этапа «Проверка правок» из проекта */
export function correctionsReviewDeadlineToDisplay(project: Pick<Project, 'corrections_review_deadline'>): string {
  return projectReviewDeadlineToDisplay(project.corrections_review_deadline);
}

/** Тело `modal_project` письма «Правки внесены»: комментарий и срок проверки правок (сервер пишет его в проект) */
export function buildCorrectionsAppliedModalPayload(
  form: CorrectionsAppliedFormState
): Omit<CorrectionsAppliedModalProjectPayload, 'email_attachment_file_ids'> {
  return {
    note: form.note.trim() || null,
    corrections_review_deadline: reviewDeadlineDisplayToApi(form.reviewDeadline),
  };
}
